import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

export let GlobalTranslate = null;
export let GlobalNavigate = null;
let GlobalCompanyId = null;
let GlobalLanguageReducer = null;
let GlobalCategoriesReducer = null;
let GlobalAccountUuidReducer = null;
let GlobalAccountReducer = null;
let GlobalAccountDetails = null;
export let GlobalFullAccess = false;
let setGlobalIsLoading = null;
export const GlobalSearchDelay = 700;
export const FirstLettersExp = /\b(\w)/gm;
export const GlobalInputDelay = 350;
export const GlobalDateFormat = "DD MMM YYYY";
export const GlobalSecondaryDateFormat = "YYYY-MM-DD";
export const GlobalTimeFormat = "HH:mm:ss";
export const GlobalDateTimeFormat = "YYYY-MM-DDTHH:mm:ssZ";
export const GlobalHijriDateFormat = "iDD iMMM iYYYY";
export const GlobalSecondHijriDateFormat = "iDD/iMM/iYYYY";
export const GlobalSavingHijriDateFormat = "iYYYY-iMM-iDD";
export const GlobalSavingDateFormat = "YYYY-MM-DD";
export const GlobalDisplayDateTimeFormat = "YYYY-MM-DD hh:mm:ss A";
export const GlobalDateAndTimeFormat = "YYYY-MM-DD hh:mm:ss";
export const ResetActiveItem = null;
export const GlobalValidationOptions = {
  // to ignore the transform for value for example translation
  // the value with only check the value before change
  strict: false,
  abortEarly: false, // to prevent stop validated on the first error (not recommended for forms)
  stripUnknown: false, // to ignore unknown variables
  recursive: true, // if false will ignore the subscheme
  context: null, // use to send a value for when (extra keys) (only objects) ex:- on https://www.npmjs.com/package/yup#mixedwhenkeys-string--arraystring-builder-object--value-schema-schema-schema
};
let logoutAction = null;
let setRerender = null;
let renderVar = false;
let setRenderVar = null;
let GlobalRoute = null;
let globalInactivityHandler = null;
let setGlobalSideExtendedBodyComponent = null;

export const SetGlobalRerender = (setRender, render) => {
  renderVar = render;
  setRenderVar = setRender;
};
export const InitGlobalRoute = ({route}) => {
  GlobalRoute = route;
};
export const GetGlobalRoute = () => {
  return GlobalRoute;
};
export const GlobalRerender = () => {
  setRenderVar(!renderVar);
};
export const InitSideExtendedBodyComponentSet = (setMethod) => {
  setGlobalSideExtendedBodyComponent = setMethod;
};
export const SideExtendedBodyComponentUpdate = (component) => {
  if (setGlobalSideExtendedBodyComponent)
    setGlobalSideExtendedBodyComponent(component);
};
export const MiddlewareHelper = () => {
  GlobalTranslate = useTranslation();
  GlobalNavigate = useNavigate();

  return null;
};
export const ChangeGlobalIsLoading = (newValue) => {
  if (setGlobalIsLoading) setGlobalIsLoading(newValue);
};
export const SetGlobalIsLoading = (setIsLoading) => {
  setGlobalIsLoading = setIsLoading;
};

export const ChangeGlobalInactivityHandler = (newProps) => {
  if (globalInactivityHandler) globalInactivityHandler(newProps);
};
export const SetGlobalInactivityHandler = (inactivityHandler) => {
  globalInactivityHandler = inactivityHandler;
};

export const GetGlobalCompanyId = () => GlobalCompanyId;
export const SetGlobalCompanyId = (newValue) => {
  GlobalCompanyId = newValue;
};
export const GetGlobalCategoriesReducer = () => GlobalCategoriesReducer;
export const SetGlobalCategoriesReducer = (newValue) => {
  GlobalCategoriesReducer = newValue;
};
export const GetGlobalLanguageReducer = () => GlobalLanguageReducer;
export const SetGlobalLanguageReducer = (newValue) => {
  GlobalLanguageReducer = newValue;
};
export const GetGlobalAccountUuidReducer = () => GlobalAccountUuidReducer;
export const SetGlobalAccountUuidReducer = (newValue) => {
  GlobalAccountUuidReducer = newValue;
};
export const GetGlobalAccountReducer = () => GlobalAccountReducer;
export const SetGlobalAccountReducer = (newValue) => {
  GlobalAccountReducer = newValue;
};
export const GetGlobalFullAccess = () => GlobalFullAccess;
export const SetGlobalFullAccess = (newValue) => {
  GlobalFullAccess = newValue;
};
export const GetGlobalAccountDetailsReducer = () => GlobalAccountDetails;
export const SetGlobalAccountDetails = (newValue) => {
  GlobalAccountDetails = newValue;
};

/**
 * Get initials of a name
 * @param string
 * @returns {string}
 */
export const getInitials = (string) => {
  const names = string.split(" ");
  let initials = names[0].substring(0, 1).toUpperCase();

  if (names && names.length > 1) {
    // This will only take into account the second index
    initials += names[1].substring(0, 1).toUpperCase();
    // This takes into account the last index (causes issues with cases like:
    // 'Firstname Lastname [Admin]', it will render 'F[' instead of 'FL'
    // initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }

  return initials;
};

export const rerenderCallback = (callback) => {
  setRerender = callback;
};

export const rerenderUpdate = (component) => {
  if (setRerender) setRerender(component);
};
export function setLogoutAction(callback) {
  logoutAction = callback;
}

export function LogoutAction() {
  return logoutAction;
}
export const getDownloadableLink = (url) => url;
export const floatHandler = (value, maxFloatNumbers) => {
  const valueAfterSplit = value.toString().split(".");
  if (
    valueAfterSplit.length === 2 &&
    valueAfterSplit[1].length > maxFloatNumbers
  )
    return Number(value).toFixed(maxFloatNumbers);
  if (
    valueAfterSplit.length === 2 &&
    valueAfterSplit[1].length <= maxFloatNumbers
  )
    return Number(value).toFixed(valueAfterSplit[1].length);

  return Number(value).toFixed(0);
};

/**
 * @param dataItem - object to get the data from it
 * @param key - the path for the data in object
 * @param isReturnAsIs - don't convert the data to string
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @Description this method is to get the data from nested object
 */
export const getDataFromObject = (dataItem, key, isReturnAsIs) => {
  if (!key)
    return (
      (typeof dataItem !== "object" &&
        (isReturnAsIs ? dataItem : `${dataItem}`)) ||
      ""
    );
  if (!key.includes("."))
    return (
      (dataItem[key] !== null &&
        dataItem[key] !== undefined &&
        (isReturnAsIs ? dataItem[key] : `${dataItem[key]}`)) ||
      ""
    );
  let a = dataItem;
  key.split(".").map((item) => {
    if (a) a = a[item];

    return item;
  });

  return a;
};
/**
 * @param str
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @Description this method is to check if the string is html or not
 */
export const isHTML = (str) => {
  const doc = new DOMParser().parseFromString(str, "text/html");

  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};
export const getErrorByName = (
  schemaObject,
  valueOrState,
  fieldName,
  type,
  validationPackage = "yup"
) => {
  if (validationPackage === "yup") {
    if (!schemaObject || !schemaObject.current)
      return {
        message: undefined,
        messages: [],
        error: true,
        type: undefined,
      };

    return schemaObject.current
      .validate(
        (typeof valueOrState === "object" && valueOrState) ||
          (fieldName && {[fieldName]: valueOrState}) ||
          null,
        GlobalValidationOptions
      )
      .then(() => ({}))
      .catch((error) => {
        if (fieldName) {
          const itemIndex = error.inner.findIndex(
            (item) => item.path === fieldName
          );
          if (itemIndex === -1)
            return {
              message: "Please make sure the path of fieldKey is correct",
              messages: error.errors || [],
              error: true,
              type: undefined,
            };

          return {
            message: error.inner[itemIndex].message,
            messages: error.errors || [],
            error: true,
            type: undefined,
          };
        }
        const errorsObjects = {};
        error.inner.map((item) => {
          errorsObjects[item.path] = {
            message: item.message,
            messages: item.messages || [],
            error: (item.message && true) || false,
            type: undefined,
          };

          return undefined;
        });

        return errorsObjects;
      });
  }
  if (
    !schemaObject.current ||
    schemaObject.current.error ||
    !schemaObject.current.error.details
  )
    return {
      message: undefined,
      messages: undefined,
      error: true,
      type: undefined,
    };

  const item = schemaObject.current.error.details.find(
    (element) =>
      (!Number.isNaN(fieldName) && element.path.includes(fieldName)) ||
      (Number.isNaN(fieldName) &&
        !fieldName.includes(".") &&
        element.path.includes(fieldName)) ||
      (Number.isNaN(fieldName) &&
        fieldName.includes(".") &&
        element.path.length >= fieldName.split(".").length &&
        element.path.slice(0, fieldName.split(".").length).join(".") ===
          fieldName)
  );
  if (!item || (type && item.type !== type))
    return {
      message: undefined,
      messages: undefined,
      error: false,
      type: undefined,
    };

  return {
    message: item.message,
    messages: item.messages,
    error: true,
    type: undefined,
  };
};

/**
 * @param str
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @Description this method is to check if the string is UUID or not
 */
export const IsUUID = (str = "") =>
  (str ? str : "").match(
    "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
  );

// eslint-disable-next-line no-bitwise
export const generateUUIDV4 = () =>
  ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );

export const formatDate = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join("-");
};

export const getNameHandler = (item, language) =>
  ((item.first_name || item.last_name) &&
    `${
      item.first_name &&
      (typeof item.first_name === "string"
        ? item.first_name
        : item.first_name[language] || item.first_name.en)
    }${
      (item.last_name &&
        ` ${
          typeof item.last_name === "string"
            ? item.last_name
            : item.last_name[language] || item.last_name.en
        }`) ||
      ""
    }`) ||
  (item.name && (item.name?.[language] || item.name?.en)) ||
  (item.title &&
    (typeof item.title === "string"
      ? item.title
      : item.title?.[language] || item.title?.en));
